import { render, staticRenderFns } from "./VerificationResult.vue?vue&type=template&id=96b39f8c&scoped=true&"
import script from "./VerificationResult.vue?vue&type=script&lang=js&"
export * from "./VerificationResult.vue?vue&type=script&lang=js&"
import style0 from "./VerificationResult.vue?vue&type=style&index=0&id=96b39f8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b39f8c",
  null
  
)

component.options.__file = "VerificationResult.vue"
export default component.exports